// extracted by mini-css-extract-plugin
var _1 = "_dashboard-module__container";
var _2 = "_dashboard-module__sub-title";
var _3 = "_dashboard-module__title";
export { _1 as "container", _2 as "sub-title", _3 as "title" }
